import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import BrandPortfolioMixin from "@/mixins/BrandPortfolioMixin.vue";
import InitializeFiltersMixin from "@/mixins/InitializeFiltersMixin.vue";
import BrandPortfolioTable from "@/components/brand_portfolio/BrandPortfolioTable.vue";
import AppCardSeo from "@/components/AppCardSeo";
import AppButtonRadioGroup from "@/components/AppButtonRadioGroup.vue";
export default {
  name: "BrandPortfolio",
  components: {
    BrandPortfolioTable,
    AppCardSeo,
    AppButtonRadioGroup
  },
  mixins: [BrandPortfolioMixin, InitializeFiltersMixin],
  data() {
    return {
      dataLoading: false,
      accountType: "my_accounts",
      accountTypeOptions: [{
        text: "My accounts",
        value: "my_accounts"
      }, {
        text: "All accounts",
        value: "all_accounts"
      }]
    };
  },
  computed: {
    ...mapState({
      sellers_filter: state => state.brand_portfolio.sellers_filter,
      isOmnyUser: state => state.auth.isOmnyUser
    }),
    currentAccountType: {
      get() {
        return this.accountType;
      },
      async set(value) {
        if (value === this.accountType) return;
        this.accountType = value;
        await this.$nextTick();
        await this.$refs.portfolioTable.refreshPortfolio();
      }
    }
  },
  async mounted() {
    this.$store.dispatch("currencyConfigSetCurrency", "EUR");
    this.dataLoading = true;
    await this.initializeSellersFilter(this.brandPortfolioSellersFilterSet);
    this.dataLoading = false;
  },
  methods: {
    ...mapMutations(["brandPortfolioSellersFilterSet"]),
    handleErrorOccured() {
      //console.log("[no account]");
      this.announceNoAccounts();
    },
    async handleRefreshSellersFilter() {
      await this.initializeSellersFilter(this.brandPortfolioSellersFilterSet);
    }
  }
};